/* eslint-disable no-plusplus */
import moment from 'moment';
import momentBusiness from 'moment-business';
import _ from 'lodash';
import { lsFilters } from '../filters';

function lessThan30DaysOld({ date }) {
    return moment().diff(moment(date), 'days') < 30;
}

function getArrayOfMonths() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
        months.push({
            label: (i < 10 ? '0' : '') + i,
            value: i,
        });
    }
    return months;
}

function getArrayOfNext20Years() {
    const currentDate = moment().toDate();
    const currentYear = currentDate.getFullYear() - 2000;
    const years = [];
    for (let i = currentYear; i <= currentYear + 20; i++) {
        years.push({
            label: (i < 10 ? '0' : '') + i,
            value: i,
        });
    }
    return years;
}

function getDateRange({ startDate, endDate }) {
    let dateText = ' ';
    if (startDate) {
        dateText += `${lsFilters.date({ date: startDate })}`;
    }
    if (endDate && startDate !== endDate) {
        dateText += `${startDate ? ' – ' : ''}${lsFilters.date({
            date: endDate,
        })}`;
    }
    return dateText;
}

function getFirstAvailDate({ sellableDays }) {
    // loop through all 5 business days, starting 2 in advance from today, and find the first that isn't marked unsellable
    for (let i = 0; i < 5; i++) {
        const dayToCheck = momentBusiness.addWeekDays(moment(), 2 + i);
        const dayString = _.toLower(dayToCheck.format('dddd'));
        if (_.get(sellableDays, dayString)) {
            return dayToCheck.toDate();
        }
    }
    return momentBusiness.addWeekDays(moment(), 2).toDate();
}

// eslint-disable-next-line import/prefer-default-export
export const lsDateHelpers = {
    lessThan30DaysOld,
    getArrayOfNext20Years,
    getArrayOfMonths,
    getDateRange,
    getFirstAvailDate,
};
